﻿// Please see documentation at https://learn.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.
// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// init Swiper:
const swiper = new Swiper('.swiper', {
    breakpoints: {
        // when window width is >= 0px
        0: {
            slidesPerView: 1,
            spaceBetween: 0
        },
        // when window width is >= 400px
        400: {
            slidesPerView: 2,
            spaceBetween: 5
        },
        // when window width is >= 700px
        700: {
            slidesPerView: 3,
            spaceBetween: 10
        },
        // when window width is >= 1000px
        1000: {
            slidesPerView: 4,
            spaceBetween: 15
        },
        // when window width is >= 1400px
        1400: {
            slidesPerView: 5,
            spaceBetween: 20
        }
    },
    mousewheel: {
        forceToAxis: true,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    // configure Swiper to use modules
    modules: [Navigation, Pagination],

});

import { Loader, LoaderOptions } from 'google-maps';

const options = { loading: "async" };
const loader = new Loader('AIzaSyBSNBgYzcupyEftZ1rElQBcBJJKtDlxzwY', options);

let map;
let markers = [];
let infoWindow;

let geocodeResultMap;
let geocodeResultMarker;

loader.load().then(function (google) {
    if (document.getElementById('map') != null) {
        initMap();
    }
    if (document.getElementById('listingMap') != null) {
        initListingMap();
    }
    if (document.getElementById('farmstandMap') != null) {
        initFarmstandMap();
    }
    if (document.getElementById('searchMap') != null) {
        initSearchMap();
    }
    if (document.getElementById('geocodeResultMap') != null) {
        initGeocodeResultMap();
    }
});

async function initMap() {
    const position = { lat: Number(document.getElementById('hdnLatitude').value), lng: Number(document.getElementById('hdnLongitude').value) };
    // Request needed libraries.
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    map = new Map(document.getElementById("map"), {
        zoom: 12,
        center: position,
        mapId: "20f7641d547ac070",
        disableDefaultUI: true,
    });

    infoWindow = new google.maps.InfoWindow();

    google.maps.event.addListener(map, 'bounds_changed', debounce(fetchAndDisplayMarkers, 375));
}

async function initListingMap() {
    const position = { lat: Number(document.getElementById('hdnFarmstandLatitude').value), lng: Number(document.getElementById('hdnFarmstandLongitude').value) };
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    let listingMap = new Map(document.getElementById("listingMap"), {
        zoom: 14,
        center: position,
        mapId: "20f7641d547ac070",
        disableDefaultUI: true,
    });

    const marker = new google.maps.marker.AdvancedMarkerElement({
        position: position,
        map: listingMap,
    });
}

async function initFarmstandMap() {
    const position = { lat: Number(document.getElementById('hdnFarmstandLatitude').value), lng: Number(document.getElementById('hdnFarmstandLongitude').value) };
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    let listingMap = new Map(document.getElementById("farmstandMap"), {
        zoom: 14,
        center: position,
        mapId: "20f7641d547ac070",
        disableDefaultUI: true,
    });

    const marker = new google.maps.marker.AdvancedMarkerElement({
        position: position,
        map: listingMap,
    });
}

async function initSearchMap() {
    const position = { lat: Number(document.getElementById('hdnLatitude').value), lng: Number(document.getElementById('hdnLongitude').value) };
    // Request needed libraries.
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    map = new Map(document.getElementById("searchMap"), {
        zoom: 12,
        center: position,
        mapId: "20f7641d547ac070",
        disableDefaultUI: true,
    });

    infoWindow = new google.maps.InfoWindow();

    google.maps.event.addListener(map, 'bounds_changed', debounce(searchAndDisplayMarkers, 375));
}

async function initGeocodeResultMap() {
    const position = { lat: Number(document.getElementById('hdnAddressLatitude').value), lng: Number(document.getElementById('hdnAddressLongitude').value) };

    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    geocodeResultMap = new Map(document.getElementById("geocodeResultMap"), {
        zoom: 14,
        center: position,
        mapId: "20f7641d547ac070",
        disableDefaultUI: true,

    });

    geocodeResultMarker = new google.maps.marker.AdvancedMarkerElement({
        position: position,
        map: geocodeResultMap,
    });
}

function addMarker({ id, position, content }) {
    if (markers[id])
        return;

    const marker = new google.maps.marker.AdvancedMarkerElement({
        position: position,
        map: map,
        // Customize the marker appearance and behavior as needed
    });

    marker.addListener('click', () => {
        infoWindow.setContent(content);
        infoWindow.open(map, marker);
        setTimeout(function () {
            new Swiper(`#${id}`, {
                slidesPerView: 1,
                spaceBetween: 0,
                mousewheel: {
                    forceToAxis: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                },
                modules: [Navigation, Pagination],
            });
        }, 10);

    });

    markers[id] = marker;
}

function setMapOnAll(map) {
    for (let i = 0; i < markers.length; i++) {
        markers[i].setMap(map);
    }
}

// Clustering function
function calculateDistance(coord1, coord2) {
    const [lat1, lng1] = coord1;
    const [lat2, lng2] = coord2;
    const dLat = lat2 - lat1;
    const dLng = lng2 - lng1;
    return Math.sqrt(dLat * dLat + dLng * dLng);
}

function clusterLocations(locations, threshold = 0.0005) {
    const clusters = [];
    const visited = new Array(locations.length).fill(false);

    for (let i = 0; i < locations.length; i++) {
        if (visited[i]) continue;

        const cluster = [];
        const stack = [i];

        while (stack.length > 0) {
            const index = stack.pop();
            if (visited[index]) continue;

            visited[index] = true;
            cluster.push(locations[index]);

            for (let j = 0; j < locations.length; j++) {
                if (!visited[j] && calculateDistance(locations[index], locations[j]) <= threshold) {
                    stack.push(j);
                }
            }
        }

        clusters.push(cluster);
    }

    return clusters;
}

function fetchAndDisplayMarkers() {
    const center = map.getBounds().getCenter();
    const lat = center.lat();
    const lng = center.lng();

    fetch('/Listing/all', {
        method: 'POST',
        headers: {
            "X-ANTI-FORGERY-TOKEN": document.getElementsByName("__RequestVerificationToken")[0].value,
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({ lat: lat, lng: lng, d: null }),
    })
        .then(response => response.json())
        .then(data => {
            // Convert data to array of [lat, lng, element] for clustering
            const locations = data.map(element => [element.latitude, element.longitude, element]);

            // Apply clustering
            const clusters = clusterLocations(locations);


            clusters.forEach(cluster => {
                // Use the first element of the cluster to represent the cluster

                let content = '';

                let id = `x${cluster[0][0]},${cluster[0][1]}`;
                id = id.replaceAll('.', '').replaceAll(',', '').replaceAll('-', '');

                cluster.forEach(element => {
                    content +=
                        `<div class="swiper-slide px-8">
                                    <a href="/listing/${element[2].id}">
                                    <div class="relative flex flex-col bg-white border rounded cursor-pointer" style="height:20rem">
                                    <div style="height:10rem">
                                    <img src="${element[2].coverMedia?.thumb}" class="object-cover rounded w-full h-full">
                                    <p class="absolute left-0 top-0 bg-lime-600 font-semibold text-white rounded-full px-3 py-1 text-sm m-2">${element[2].categories[0]}</p>
                                    </div><div class="flex flex-col justify-between grow p-2">
                                    <div class="flex flex-col">
                                    <h1 class="font-bold text-md text-base mb-2 text-center line-clamp-1">${element[2].name}</h1>
                                                    <p class="opacity-40 text-sm text-pretty line-clamp-3">${element[2].description}</p>
                                    </div><div class="flex justify-between mt-5 text-sm ">
                                    <p>$${element[2].price} / ${element[2].unit}</p><p>${element[2].location}</p>
                                    </div>
                                    </div>
                                    </div>
                                    </a>
                                    </div>
                                    `
                })

                content = `<div class="swiper-button-prev"></div><div id="${id}" class="swiper"><div class="swiper-wrapper">` + content + '</div></div><div class="swiper-button-next"></div>'

                addMarker({
                    id: id,
                    position: { lat: cluster[0][0], lng: cluster[0][1] },
                    content: content
                });
            });
        })
        .catch((error) => {
                console.error('Error:', error);
        });
}

function searchAndDisplayMarkers() {
    const center = map.getBounds().getCenter();
    const lat = center.lat();
    const lng = center.lng();

    let query = document.getElementById('search').value;

    fetch('/listing/q', {
        method: 'POST',
        headers: {
            "X-ANTI-FORGERY-TOKEN": document.getElementsByName("__RequestVerificationToken")[0].value,
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        credentials: "include",
        body: JSON.stringify({ q: query, lat: lat, lng: lng, meters: null }),
    })
        .then(response => response.json())
        .then(responseData => {
            let resultsContainer = document.getElementById('js-results');
            let htmlContent = '';

            let data = responseData.listings;

            data.forEach((value) => {
                htmlContent += `
                                  <li class="relative flex justify-between gap-x-6 hover:bg-gray-50">
                                    <div class="flex min-w-0 grow gap-x-4">
                                      <img class="h-24 w-24 flex-none bg-gray-50" src="${value.coverMedia?.thumb}" alt="">
                                      <div class="min-w-0 flex-auto py-2">
                                        <p class="leading-6 line-clamp-1 text-ellipsis text-sm font-semibold text-gray-900">
                                          <a href="/listing/${value.id}">
                                            <span class="absolute inset-x-0 -top-px bottom-0"></span>
                                            ${value.name}
                                          </a>
                                        </p>
                                        <p class="leading-5 line-clamp-2 mt-1 flex text-ellipsis text-xs text-gray-500">
                                        ${value.description}
                                        </p>
                                        <p class="leading-6 line-clamp-1 ml-auto self-end text-ellipsis text-right text-sm text-gray-900">$${value.price} / ${value.unit}</p>
                                      </div>
                                    </div>
                                    <div class="shrink-0 flex items-center gap-x-4">
                                      <svg class="h-5 w-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                                        <path fill-rule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                                      </svg>
                                    </div>
                                  </li>`;
            });

            if (htmlContent === '' && responseData.noResultsForOriginalTerm === true) {
                document.getElementById('js-results-none').classList.remove('hidden');
                document.getElementById('js-results-other').classList.add('hidden');
            } else if (responseData.noResultsForOriginalTerm === true) {
                document.getElementById('js-results-other').classList.remove('hidden');
                document.getElementById('js-results-none').classList.add('hidden');
            } else {
                document.getElementById('js-results-other').classList.add('hidden');
                document.getElementById('js-results-none').classList.add('hidden');
            }

            resultsContainer.innerHTML = htmlContent;

            // Convert data to array of [lat, lng, element] for clustering
            const locations = data.map(element => [element.latitude, element.longitude, element]);

            // Apply clustering
            const clusters = clusterLocations(locations);

            clusters.forEach(cluster => {
                // Use the first element of the cluster to represent the cluster

                let content = '';

                let id = `x${cluster[0][0]},${cluster[0][1]}`;
                id = id.replaceAll('.', '').replaceAll(',', '').replaceAll('-', '');

                cluster.forEach(element => {
                    content +=
                        `<div class="swiper-slide px-8">
                                    <a href="/listing/${element[2].id}">
                                    <div class="relative flex flex-col bg-white border rounded cursor-pointer" style="height:20rem">
                                    <div style="height:10rem">
                                    <img src="${element[2].coverMedia?.thumb}" class="object-cover rounded w-full h-full">
                                    <p class="absolute left-0 top-0 bg-lime-600 font-semibold text-white rounded-full px-3 py-1 text-sm m-2">${element[2].categories[0]}</p>
                                    </div><div class="flex flex-col justify-between grow p-2">
                                    <div class="flex flex-col">
                                    <h1 class="font-bold text-md text-base mb-2 text-center line-clamp-1">${element[2].name}</h1>
                                                    <p class="opacity-40 text-sm text-pretty line-clamp-3">${element[2].description}</p>
                                    </div><div class="flex justify-between mt-5 text-sm ">
                                    <p>$${element[2].price} / ${element[2].unit}</p><p>${element[2].location}</p>
                                    </div>
                                    </div>
                                    </div>
                                    </a>
                                    </div>
                                    `
                })

                content = `<div class="swiper-button-prev"></div><div id="${id}" class="swiper"><div class="swiper-wrapper">` + content + '</div></div><div class="swiper-button-next"></div>'

                addMarker({
                    id: id,
                    position: { lat: cluster[0][0], lng: cluster[0][1] },
                    content: content
                });
            });

        })
        .catch((error) => {
                console.error('Error:', error);
        });
}

function setMapCenter(position) {
    if (!!map) {
        map.setCenter(position);
    } else {
        Sentry.captureMessage("map undefined");
    }
}

function updateGeocodeResultMap(position) {
    geocodeResultMap.setCenter(position);
    geocodeResultMarker.map = null;
    geocodeResultMarker = new google.maps.marker.AdvancedMarkerElement({
        position: position,
        map: geocodeResultMap,
    });
}

function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

window.fetchAndDisplayMarkers = fetchAndDisplayMarkers;
window.searchAndDisplayMarkers = searchAndDisplayMarkers;
window.setMapCenter = setMapCenter;
window.updateGeocodeResultMap = updateGeocodeResultMap;
window.swiper = swiper;